import SiteShell from "../components/SiteShell";
import DiagramFlow from "../components/DiagramFlow";

const companyCards = [
  {
    title: "Our Mission",
    text: "Make personal loans for salaried customers instant, secure and available through a simple kiosk experience.",
    image: "https://images.unsplash.com/photo-1579621970795-87facc2f976d",
  },
  {
    title: "What Makes Us Different",
    text: "We are focused on one clear promise: less than 4-minute personal loan journey with banking-grade controls.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
  },
  {
    title: "Built in India",
    text: "Designed and operated from Gurgaon to deliver India's first dedicated instant salaried personal loan kiosk model.",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
  },
];

function Company() {
  return (
    <SiteShell
      route="company"
      heroHidden={true}
    >
      <section className="relative overflow-hidden bg-[#061a2e] pb-16 pt-24 text-white">
        <div className="absolute inset-0 z-0 opacity-20">
          <div className="absolute top-0 right-0 h-full w-full bg-[radial-gradient(circle_at_100%_0%,#df1f2d_0%,transparent_50%)]" />
        </div>
        <div className="relative z-10 mx-auto max-w-[1280px] px-6 text-center md:px-10">
          <span className="inline-flex rounded-full bg-white/10 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.25em] text-sky-300 ring-1 ring-white/20 backdrop-blur-md">
            Our Mission
          </span>
          <h1 className="mt-8 text-4xl font-extrabold leading-tight tracking-tight md:text-7xl">
            Pioneering the Future <br />of Instant Credit
          </h1>
          <p className="mt-8 mx-auto max-w-3xl text-lg text-sky-100/80 leading-relaxed font-medium">
            We are a category-defining finnCube company. Our focus is absolute: delivering secure, sub-4-minute personal loan approvals for salaried professionals.
          </p>
          <div className="mt-12 flex justify-center gap-4 text-[11px] font-black uppercase tracking-widest">
            <a href="tel:+919876543210" className="rounded-full bg-[#e37921] px-10 py-5 text-white shadow-2xl transition-all hover:-translate-y-1 hover:bg-[#e37921]">Connect Us</a>
            <a href="https://www.google.com/maps/dir/?api=1&destination=Plot+No-296+Finncube+Credit+Services+Pvt.+Ltd.+Udyog+Vihar+phase+4+Gurugram+Haryana+122015" className="rounded-full border border-white/20 bg-white/5 px-10 py-5 text-white backdrop-blur-md transition-all hover:bg-white/10">Locate HQ</a>
          </div>
        </div>
      </section>
      <DiagramFlow
        title="Foundational Pillars"
        subtitle="Our vision is executed through a relentless focus on kinetic speed, institutional trust, and national scalability."
        steps={[
          { title: "Visionary Core", text: "Defining the standard for high-speed physical credit touchpoints." },
          { title: "Kinetic UX", text: "Engineering every millisecond of the customer journey for minimum friction." },
          { title: "Safety First", text: "Uncompromising banking-grade security built into every packet of data." },
          { title: "Regional Impact", text: "Starting from Gurgaon, scaling to empower professionals pan-India." },
        ]}
      />

      <section className="mx-auto max-w-[1280px] px-6 py-20 md:px-10">
        <h2 className="text-3xl font-extrabold tracking-tight text-[#0a2c4f] md:text-5xl text-center mb-16">The KIOSK Identity</h2>
        <div className="grid gap-8 md:grid-cols-3">
          {companyCards.map((card) => (
            <article
              key={card.title}
              className="group overflow-hidden rounded-[32px] border border-slate-100 bg-white p-2 shadow-xl transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative h-56 overflow-hidden rounded-[24px]">
                <img src={card.image} alt={card.title} className="h-full w-full object-cover transition duration-700 group-hover:scale-110" />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-bold tracking-tight text-[#0a2c4f]">{card.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">{card.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-6 pb-24 md:px-10">
        <div className="grid gap-16 md:grid-cols-[0.9fr_1.1fr]">
          <div className="relative group">
            <div className="absolute -inset-4 bg-gradient-to-br from-[#df1f2d] to-navy opacity-5 blur-2xl transition duration-500 group-hover:opacity-10" />
            <img
              src="/team_premium_office_1772861377531.png"
              alt="Team and operations"
              className="relative h-[450px] w-full rounded-[40px] border border-slate-200 object-cover shadow-2xl"
            />
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-[15px] font-black uppercase tracking-[0.25em] text-[#e37921]">
              Our DNA
            </p>
            <h2 className="mt-6 text-4xl font-extrabold tracking-tight text-[#0a2c4f] md:text-5xl">
              Focused Logic. <br />Infinite Trust.
            </h2>
            <p className="mt-8 text-base leading-relaxed text-slate-500">
              We started with a simple question: Why should credit take days? By combining physical accessibility with deep-tech digital speed, we've created a lending experience that is both remarkably fast and inherently secure.
            </p>
            <div className="mt-12 overflow-hidden rounded-3xl bg-[#0a2c4e] p-8 text-white shadow-xl relative">
              <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-sky-400 opacity-20 blur-2xl" />
              <p className="text-[10px] uppercase font-black tracking-widest text-sky-300">Headquarters</p>
              <p className="mt-2 text-xl font-bold">9th Floor, 954/AB, JMD Megapolis, Sohna Road, Gurugram, Haryana,122018</p>
              <div className="mt-8 flex gap-4">
                <div className="h-0.5 flex-1 bg-white/10" />
                <div className="h-0.5 w-12 bg-[#e37921]" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}

export default Company;
